import { ProfileDetail } from '@helpers/types/profileDetail';

export const usersProfileDetails: ProfileDetail[] = [
  {
    from: 'Montserrat',
    relationship: 'Engaged',
    age: 48,
    company: 'Billmed',
    description: 'velit aliquip aliquip do',
  },
  {
    from: 'Israel',
    relationship: 'Married',
    age: 36,
    company: 'Comcubine',
    description: 'proident consectetur elit non',
  },
  {
    from: 'Niger',
    relationship: 'Single',
    age: 28,
    company: 'Tersanki',
    description: 'fugiat id laboris aute',
  },
  {
    from: 'Panama',
    relationship: 'Engaged',
    age: 36,
    company: 'Dogspa',
    description: 'quis id non id',
  },
  {
    from: 'Hungary',
    relationship: 'Single',
    age: 37,
    company: 'Essensia',
    description: 'cillum do tempor anim',
  },
  {
    from: 'Sweden',
    relationship: 'Married',
    age: 18,
    company: 'Turnling',
    description: 'aliqua ullamco nulla duis',
  },
  {
    from: 'Northern Mariana Islands',
    relationship: 'Married',
    age: 40,
    company: 'Artiq',
    description: 'eu incididunt excepteur commodo',
  },
  {
    from: 'Malaysia',
    relationship: 'Single',
    age: 43,
    company: 'Futuris',
    description: 'quis mollit nostrud pariatur',
  },
  {
    from: 'Christmas Island',
    relationship: 'Engaged',
    age: 22,
    company: 'Comtract',
    description: 'commodo excepteur ut cillum',
  },
  {
    from: 'Gibraltar',
    relationship: 'Single',
    age: 21,
    company: 'Metroz',
    description: 'qui mollit ipsum irure',
  },
  {
    from: 'Luxembourg',
    relationship: 'Single',
    age: 32,
    company: 'Stucco',
    description: 'mollit duis nostrud enim',
  },
  {
    from: 'San Marino',
    relationship: 'Engaged',
    age: 28,
    company: 'Freakin',
    description: 'eu irure ut laboris',
  },
  {
    from: 'Saint Kitts and Nevis',
    relationship: 'Married',
    age: 28,
    company: 'Enquility',
    description: 'pariatur quis et fugiat',
  },
  {
    from: 'Afghanistan',
    relationship: 'Engaged',
    age: 30,
    company: 'Tubalum',
    description: 'laborum irure minim nisi',
  },
  {
    from: 'Bosnia and Herzegovina',
    relationship: 'Married',
    age: 19,
    company: 'Temorak',
    description: 'nostrud commodo consequat dolor',
  },
  {
    from: 'French Polynesia',
    relationship: 'Single',
    age: 23,
    company: 'Speedbolt',
    description: 'elit eiusmod laboris aliqua',
  },
  {
    from: 'Russian Federation',
    relationship: 'Married',
    age: 43,
    company: 'Translink',
    description: 'dolor adipisicing proident do',
  },
  {
    from: 'Martinique',
    relationship: 'Engaged',
    age: 50,
    company: 'Enthaze',
    description: 'velit incididunt esse cillum',
  },
  {
    from: 'Georgia',
    relationship: 'Single',
    age: 34,
    company: 'Panzent',
    description: 'do reprehenderit sint anim',
  },
  {
    from: 'Jamaica',
    relationship: 'Single',
    age: 49,
    company: 'Uxmox',
    description: 'mollit sunt elit nisi',
  },
  {
    from: 'Poland',
    relationship: 'Married',
    age: 43,
    company: 'Accel',
    description: 'sint sint ullamco duis',
  },
  {
    from: 'Antarctica',
    relationship: 'Single',
    age: 42,
    company: 'Rameon',
    description: 'voluptate nulla minim dolore',
  },
  {
    from: 'Sudan',
    relationship: 'Engaged',
    age: 18,
    company: 'Zolarex',
    description: 'laborum minim deserunt cillum',
  },
  {
    from: 'Iran',
    relationship: 'Married',
    age: 32,
    company: 'Isoternia',
    description: 'eu nisi do sit',
  },
  {
    from: 'Seychelles',
    relationship: 'Married',
    age: 48,
    company: 'Exovent',
    description: 'sunt pariatur dolor cupidatat',
  },
  {
    from: 'Chile',
    relationship: 'Engaged',
    age: 49,
    company: 'Austex',
    description: 'non veniam minim culpa',
  },
  {
    from: 'Zimbabwe',
    relationship: 'Engaged',
    age: 27,
    company: 'Steelfab',
    description: 'ea est ea id',
  },
  {
    from: 'S. Georgia and S. Sandwich Isls.',
    relationship: 'Single',
    age: 37,
    company: 'Nurplex',
    description: 'qui nulla occaecat consectetur',
  },
  {
    from: 'Malawi',
    relationship: 'Engaged',
    age: 26,
    company: 'Minga',
    description: 'sit ex enim sunt',
  },
  {
    from: 'Peru',
    relationship: 'Single',
    age: 44,
    company: 'Jetsilk',
    description: 'culpa elit consequat sunt',
  },
  {
    from: 'Nauru',
    relationship: 'Engaged',
    age: 37,
    company: 'Telequiet',
    description: 'qui incididunt dolor occaecat',
  },
  {
    from: 'Dominica',
    relationship: 'Married',
    age: 28,
    company: 'Kineticut',
    description: 'et do tempor dolor',
  },
  {
    from: 'Armenia',
    relationship: 'Engaged',
    age: 41,
    company: 'Codact',
    description: 'ex est exercitation nisi',
  },
  {
    from: 'Egypt',
    relationship: 'Married',
    age: 43,
    company: 'Elemantra',
    description: 'sit amet ullamco qui',
  },
  {
    from: 'Mauritania',
    relationship: 'Engaged',
    age: 20,
    company: 'Zialactic',
    description: 'excepteur in tempor veniam',
  },
  {
    from: 'Cameroon',
    relationship: 'Married',
    age: 20,
    company: 'Eplosion',
    description: 'exercitation adipisicing veniam anim',
  },
  {
    from: 'Ethiopia',
    relationship: 'Married',
    age: 20,
    company: 'Cogentry',
    description: 'sint pariatur aliquip officia',
  },
  {
    from: 'Uganda',
    relationship: 'Married',
    age: 25,
    company: 'Xixan',
    description: 'incididunt cupidatat nisi nisi',
  },
  {
    from: 'Netherlands Antilles',
    relationship: 'Engaged',
    age: 42,
    company: 'Strezzo',
    description: 'reprehenderit reprehenderit deserunt nulla',
  },
  {
    from: 'Senegal',
    relationship: 'Engaged',
    age: 24,
    company: 'Zensus',
    description: 'amet minim et ipsum',
  },
];
